import { Box, Divider, Stack } from "@mui/material";
import { IconLocationNotAvailable } from "src/components/icons-mui/location-not-available";
import { Button } from "src/components-mui/base/button/button";
import { Typography } from "src/components-mui/base/typography/typography";
import { DeclareInterestButton } from "src/components-mui/common/buttons/declare-interest-button/declare-interest-button";
import { CBDetailsAccordion } from "src/components-mui/pages/detail/certificate-box/components/details-accordion";
import { CBFooter } from "src/components-mui/pages/detail/certificate-box/components/footer";
import { CBHeader } from "src/components-mui/pages/detail/certificate-box/components/header/header";
import { InfoBox } from "src/components-mui/pages/detail/certificate-box/components/info-box";
import { CBInvestedCapital } from "src/components-mui/pages/detail/certificate-box/components/invested-capital";
import { CBPrices } from "src/components-mui/pages/detail/certificate-box/components/prices";
import { CBRatioTabBar } from "src/components-mui/pages/detail/certificate-box/components/ratio-tab-bar";
import { SpacedContainer } from "src/components-mui/pages/detail/certificate-box/components/spaced-container";
import {
    CBCertificateFee,
    CBEmission,
    CBExchangeRatio,
    CBLiquidationFigure,
    CBPerformanceFee,
    CBTradingVolume,
} from "src/components-mui/pages/detail/certificate-box/components/statistics";
import { useCertificateBoxContext } from "src/components-mui/pages/detail/certificate-box/context";

const NOT_LICENSED_MESSAGE_TEST_ID = "not-licensed-message";
const FIND_INVESTABLE_BUTTON_TEST_ID = "find-investable-button";

export const CertificateBoxNotLicensedAll = () => {
    const { dict, data, selectedCertificate: certificate } = useCertificateBoxContext();
    const isHiddenCertificate = certificate.isHidden;

    return (
        <>
            <CBHeader />
            <SpacedContainer>
                {data.certificates.length > 1 && <CBRatioTabBar />}
                <CBPrices />
                <Divider />

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <CBCertificateFee />
                    <CBPerformanceFee />
                    <CBInvestedCapital />
                </Box>
                <Divider />

                <CBDetailsAccordion>
                    <Stack sx={{ gap: 1 }}>
                        <CBEmission />
                        <CBLiquidationFigure />
                        <CBTradingVolume />
                        {isHiddenCertificate && <CBExchangeRatio />}
                    </Stack>
                    <Divider sx={{ pt: 2 }} />
                </CBDetailsAccordion>

                <InfoBox icon={<IconLocationNotAvailable sx={{ mt: 0.2, width: "18px", height: "18px" }} />}>
                    <Typography
                        data-test-id={NOT_LICENSED_MESSAGE_TEST_ID}
                        sx={{
                            fontSize: "sm",
                        }}
                    >
                        {dict.notLicensedMessage}
                    </Typography>
                </InfoBox>

                <Stack spacing={1}>
                    {certificate.findInvestableUrl && (
                        <Button
                            component="a"
                            href={certificate.findInvestableUrl}
                            color="green"
                            size="medium"
                            data-test-id={FIND_INVESTABLE_BUTTON_TEST_ID}
                        >
                            {dict.findInvestableButton}
                        </Button>
                    )}
                    <DeclareInterestButton variant="outlined" size="medium" wikifolioId={data.wikifolio.id}>
                        {dict.declareInterestButton}
                    </DeclareInterestButton>
                </Stack>

                <CBFooter />
            </SpacedContainer>
        </>
    );
};
